import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    // name: "issueBank",
    component: () => import('@/views/resp/map/index')
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/resp/home.vue')
  },
  // 历史信息页
  {
    path: '/hisdetail',
    name: 'hisdetail',
    component: () => import('@/views/resp/history/detail')
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/public/success')
  },
  {
    path: '/zjxqdetail',
    name: 'zjxqdetail',
    meta: { title: '意见征集' },
    component: () => import('@/views/resp/history/zjxqDetail')
  },
  {
    path: '/district',
    name: 'district',
    component: () => import('@/views/resp/district/index.vue')
  },
  // 联络站列表
  {
    path: '/llzList',
    name: 'llzList',
    component: () => import('@/views/resp/llzOrangnize/list.vue')
  },
  // 代表列表
  {
    path: '/dbList',
    name: 'dbList',
    component: () => import('@/views/resp/llzOrangnize/dbList.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index')
  },
  {
    path: '/LLZmap',
    name: 'LLZmap',
    component: () => import('../views/resp/map/index')
  },
  {
    path: '/LLZdetail',
    name: 'LLZdetail',
    component: () => import('../views/resp/map/detail.vue')
  },
  // 代表信息页面
  {
    path: '/Dbinfo',
    name: 'Dbinfo',
    component: () => import('../views/resp/Dbinfo/detail.vue')
  },
  // 提意见建议页
  {
    path: '/suggess',
    name: 'suggess',
    component: () => import('../views/resp/Dbinfo/suggess.vue')
  },
  {
    path: '/pdfPreview',
    name: 'pdfPreview',
    component: () => import('@/views/resp/history/pdfPreview.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 重复点击路由的问题
// // 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}
// router.beforeEach((to, from, next) => {
//   if (to.name === 'login') {
//     return next()
//   }

// //   if (store.state.user.token) {
// //     return next()
// //   } else {
// //     return next({
// //       name: 'login'
// //     })
// //   }
//   if (localStorage.getItem('openid')) {
//     return next()
//   } else {
//     this.$toast.success('')
//     return next({
//       name: 'login'
//     })
//   }
//   Dialog.confirm({
//     title: '使用该功能需要登录，确认登录吗？'
//   }).then(() => {
//     next({
//       name: 'login'
//     })
//   }).catch(() => {
//     // on cancel
//   })
// })
const createRouter = () =>
  new VueRouter({
    mode: 'hash', // require service support
    base: '/srddbgz/',
    scrollBehavior (to, from, savedPosition) {
      // keep-alive 返回缓存页面后记录浏览位置
      if (savedPosition) {
        return savedPosition
      }
      // 异步滚动操作
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            x: 0,
            y: 0
          })
        }, 0)
      })
      // return { x: 0, y: 0 }
    },
    routes: routes
  })
// 重置路由
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重新设置路由的可匹配路径
}
router.beforeEach((to, from, next) => {
  if (to.meta?.title) document.title = to.meta.title
  next()
})
export default router
